<template>
	<v-card outlined class = "access-control-events-card access-control-settings-region access-control-settings-region--events">
		<v-card-title class = "pa-1 secondary white--text body-2">
			<v-icon small color = "white" class = "mr-1">mdi-calendar-clock</v-icon>
			<span>{{ $ml.get('access_control_events') }}</span>
		</v-card-title>
		<v-card-text class = "pa-4 access-control-events-card__body">
			<v-list dense>
				<v-list-item>
					<v-list-item-content>
						<v-list-item-title>{{ deviceName }}</v-list-item-title>
						<v-list-item-subtitle>{{ deviceId }}</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>
			</v-list>

			<v-alert v-if = "!normalizedEvents.length" dense outlined type = "info" class = "mb-3">
				Aún no hay eventos del terminal. Cuando lleguen eventos reales se mostrarán aquí los accesos, cambios de puerta, ruta/match y origen.
			</v-alert>

			<div v-if = "tableEvents.length" class = "access-control-events-table-wrapper">
			<v-simple-table
				dense
				class = "access-control-events-table"
			>
				<thead>
					<tr>
						<th
							v-for = "header in headers"
							:key = "header.value"
							class = "text-left caption"
						>
							{{ header.text }}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr
						v-for = "event in tableEvents"
						:key = "event.id"
					>
						<td>
							{{ event.occurred_at }}
						</td>
						<td>{{ event.device_label }}</td>
						<td>{{ event.user_label }}</td>
						<td>{{ event.method }}</td>
						<td>
							<v-chip
								x-small
								:color = "event.is_successful_access ? 'success' : 'secondary'"
								text-color = "white"
							>
								{{ event.status }}
							</v-chip>
						</td>
						<td>{{ event.door_status }}</td>
						<td>{{ event.reader_id }}</td>
						<td>{{ event.match_route }}</td>
						<td>{{ event.source_label }}</td>
					</tr>
				</tbody>
			</v-simple-table>
			</div>
		</v-card-text>
	</v-card>
</template>

<script>
	import { ACCESS_CONTROL_EVENT_FIELDS, formatAccessControlEvent } from './accessControlEvents.js'

	export default {
		name: 'access_control_events',
		props: [
			'info_to_device',
			'info_device',
			'events',
		],
		computed: {
			device(){
				return this.info_to_device || this.info_device || {}
			},
			deviceName(){
				return this.device.name || 'ACCESS CONTROL'
			},
			deviceId(){
				return this.device.deviceId || this.device.id || 'N/A'
			},
			headers(){
				return ACCESS_CONTROL_EVENT_FIELDS.map(field => ({
					text: this.labelFor(field),
					value: field,
				}))
			},
			eventSource(){
				return this.events || this.device.events || this.device.accessControlEvents || this.device.access_control_events || []
			},
			normalizedEvents(){
				const rows = Array.isArray(this.eventSource) ? this.eventSource : [this.eventSource]
				return rows
					.filter(item => item && typeof item === 'object')
					.map(item => formatAccessControlEvent(item, this.translate))
			},
			tableEvents(){
				return this.normalizedEvents
			},
		},
		methods: {
			translate(key){
				return this.$ml && this.$ml.get ? this.$ml.get(key) : key
			},
			labelFor(field){
				const labels = {
					occurred_at: 'Hora',
					device_label: 'Dispositivo',
					user_label: 'Usuario',
					method: 'Método',
					status: 'Estado',
					door_status: 'Puerta',
					reader_id: 'Lector',
					match_route: 'Ruta/Match',
					source_label: 'Origen',
				}
				return labels[field] || field
			},
		},
	}
</script>

<style scoped>
	.access-control-events-table{
		min-width: 840px;
		margin-top: 0;
	}

	.access-control-events-card{
		width: 100%;
	}

	.access-control-settings-region{
		min-width: 0;
	}

	.access-control-events-table-wrapper{
		max-width: 100%;
		overflow-x: auto;
	}

	.access-control-events-card__body{
		overflow-x: auto;
	}

	.access-control-events-table th,
	.access-control-events-table td{
		white-space: nowrap;
		padding-left: 8px;
		padding-right: 8px;
	}
</style>
